import {lazy} from 'react'
import {RouteObject} from 'react-router-dom'
import {AppHelmet} from '../../components/utils/AppHelmet'
import {AppLayout} from '../../components/utils/AppLayout'
import {PageSuspenseFallback} from '../../components/utils/PageSuspenseFallback'
// import {SUPER_ADMIN_EMAIL_REGEX} from '../../config/env'
import {AuthProtectedLayout} from '../auth/components/AuthProtectedLayout'

const EntityPage = lazy(() => import('./pages/EntityPage'))
const EntityCreatePage = lazy(() => import('./pages/EntityCreatePage'))
const EntityEditPage = lazy(() => import('./pages/EntityEditPage'))

export const ENTITY_ROUTES: RouteObject[] = [
  {
    path: '/entities',
    element: (
      <>
        <AppHelmet title='Entities' />
        <AuthProtectedLayout adminOnly>
          <AppLayout>
            <PageSuspenseFallback>
              <EntityPage />
            </PageSuspenseFallback>
          </AppLayout>
        </AuthProtectedLayout>
      </>
    ),
    children: [
      {
        path: '/entities/create',
        element: (
          <>
            <AppHelmet title='Entity create' />
            <PageSuspenseFallback>
              <EntityCreatePage />
            </PageSuspenseFallback>
          </>
        ),
      },
      {
        path: '/entities/:entityCode/edit',
        element: (
          <>
            <AppHelmet title='Entity edit' />
            <PageSuspenseFallback>
              <EntityEditPage />
            </PageSuspenseFallback>
          </>
        ),
      },
    ],
  },
]
